import React, { useEffect, useState } from 'react';
import { CheckCircle, XCircle, AlertCircle, Info, X } from 'lucide-react';
import { toast, Toast } from '../lib/toast';

export default function ToastContainer() {
  const [toasts, setToasts] = useState<Toast[]>([]);

  useEffect(() => {
    const unsubscribe = toast.subscribe(setToasts);
    return unsubscribe;
  }, []);

  if (toasts.length === 0) return null;

  return (
    <div className="fixed top-4 right-4 z-50 space-y-2 max-w-md">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`rounded-lg shadow-lg p-4 flex items-start space-x-3 animate-slide-in ${
            t.type === 'success'
              ? 'bg-green-50 border border-green-200'
              : t.type === 'error'
              ? 'bg-red-50 border border-red-200'
              : t.type === 'warning'
              ? 'bg-yellow-50 border border-yellow-200'
              : 'bg-blue-50 border border-blue-200'
          }`}
        >
          <div className="flex-shrink-0">
            {t.type === 'success' && <CheckCircle className="h-5 w-5 text-green-600" />}
            {t.type === 'error' && <XCircle className="h-5 w-5 text-red-600" />}
            {t.type === 'warning' && <AlertCircle className="h-5 w-5 text-yellow-600" />}
            {t.type === 'info' && <Info className="h-5 w-5 text-blue-600" />}
          </div>
          <div className="flex-1 min-w-0">
            <p
              className={`text-sm font-medium ${
                t.type === 'success'
                  ? 'text-green-900'
                  : t.type === 'error'
                  ? 'text-red-900'
                  : t.type === 'warning'
                  ? 'text-yellow-900'
                  : 'text-blue-900'
              }`}
            >
              {t.message}
            </p>
          </div>
          <button
            onClick={() => toast.dismiss(t.id)}
            className={`flex-shrink-0 ${
              t.type === 'success'
                ? 'text-green-500 hover:text-green-700'
                : t.type === 'error'
                ? 'text-red-500 hover:text-red-700'
                : t.type === 'warning'
                ? 'text-yellow-500 hover:text-yellow-700'
                : 'text-blue-500 hover:text-blue-700'
            }`}
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      ))}
    </div>
  );
}
